// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiShowInferencer } from "@refinedev/inferencer/mui";

// export const PurshaseShow: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiShowInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };


import { Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import {
  DateField,
  NumberField,
  Show
} from "@refinedev/mui";

export const PurshaseShow = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        
        <Typography variant="body1" fontWeight="bold">
          Quantity
        </Typography>
        <NumberField value={record?.quantity ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Source
        </Typography>
        <NumberField value={record?.source ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Prix
        </Typography>
        <NumberField value={record?.prix ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Reste
        </Typography>
        <NumberField value={record?.reste ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Created At
        </Typography>
        <DateField value={record?.createdAt} />
        <Typography variant="body1" fontWeight="bold">
          Container
        </Typography>

        {/* {containerIsLoading ? (
          <>Loading...</>
        ) : (
          <>{containerData?.data?.name}</>
        )}
        <Typography variant="body1" fontWeight="bold">
          User
        </Typography>
        <TextField value={record?.user?.username} /> */}
      </Stack>
    </Show>
  );
};
